import type React from 'react';
import { type ComponentProps, createContext, useContext } from 'react';
import {
  EjnFiltersProvider,
  EjnListProvider,
  EjnSelectedProvider,
} from './ejn';

const providers: React.FC<{ children?: React.ReactNode }>[] = [
  EjnListProvider,
  EjnFiltersProvider,
  EjnSelectedProvider,
];

const combineContexts = (
  contexts: React.FC<{ children?: React.ReactNode }>[],
): React.FC<{ children?: React.ReactNode }> =>
  contexts.reduce(
    (AccumulatedContext, CurrentContext) =>
      ({
        children,
      }: ComponentProps<React.FC<{ children?: React.ReactNode }>>) => (
        <AccumulatedContext>
          <CurrentContext>{children}</CurrentContext>
        </AccumulatedContext>
      ),
    ({ children }) => <>{children}</>,
  );

const CombinedContexts = combineContexts(providers);

const AppContext = createContext({});

export const AppContextProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <AppContext.Provider value={{}}>
      <CombinedContexts>{children}</CombinedContexts>
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
